import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import t from "../locales";
import { useMessagesStore } from "../store/messages";

export default function SystemMessage({
  text,
  type = "ok",
  saveStateName = null,
  specialZIndex = false,
}) {
  const dismissedMessages = useMessagesStore((s) => s.dismissedMessages);
  const setDismissed = useMessagesStore((s) => s.setDismissed);
  const [internal, setInternal] = useState(false);
  const seen = dismissedMessages.includes(saveStateName);
  const ignore = window.location.search.includes("ignoreMessage=true");
  const className = specialZIndex
    ? "system-message system-message--high-z-index"
    : "system-message ";

  useEffect(() => {
    if (seen || internal) return;

    const container = document.querySelector(".main-container");
    container?.style.setProperty("overflow", "hidden");

    return () =>
      document
        .querySelector(".main-container")
        ?.style.removeProperty("overflow");
  }, []);

  useEffect(() => {
    if (!internal) return;

    document.querySelector(".main-container").style.removeProperty("overflow");
    if (saveStateName !== null) setDismissed(saveStateName);
  }, [internal, saveStateName]);

  if (ignore || seen || internal) return null;

  return (
    <div className={className}>
      <div className="system-message__overlay"></div>
      <div className="system-message__card">
        <p className="system-message__text">{text}</p>
        {type === "ok" && (
          <button
            className="system-message__button"
            onClick={() => setInternal(true)}
          >
            {t("system_message_ok")}
          </button>
        )}
        {type === "notAllowed" && (
          <Link className="system-message__button" to="/apps">
            {t("system_message_go_back")}
          </Link>
        )}
      </div>
    </div>
  );
}
